import React, { FC } from 'react'

// style
import '../../../../../_jutemplate/assets/css/custom.css'

// icon
import { ListIcon } from '../../../../../assets/svg/dashboard/ListIcon';

// componet
import { ListTitle } from './ListTitle';
import { ListSubTitle } from './ListSubTitle';


interface LandListProps {
  onClick:()=>void;
  landName:string;
  aggregatorName:string;
  userName:string;
}


export const LandList:FC<LandListProps> = ({onClick:handleListClick,landName,aggregatorName,userName}) => {
  
  return (
    <li className='px-5 py-3 rounded-2 d-flex align-items-center gap-4 dashboard-list' style={{cursor:'pointer'}} onClick={handleListClick}>
        <ListIcon/>
        <div className='d-flex flex-column gap-1'>
        <ListTitle>{landName}</ListTitle>
        <ListSubTitle>{`${userName}, ORG: ${aggregatorName}`}</ListSubTitle>
        </div>
    </li>
  )
}
